import script from "./RegistrationForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegistrationForm.vue?vue&type=script&setup=true&lang=js"

import "./RegistrationForm.vue?vue&type=style&index=0&id=34169468&lang=css"

const __exports__ = script;

export default __exports__